import { useSelector, useDispatch } from 'react-redux';
import FJImageEnhancerRight from './FJImageEnhancerRight';
import { setSliceIsDraggingFileAction } from '../../../redux/slices/FJSliceCommon';
import FJActionImageEnhancer from '../../../redux/action/FJActionImageEnhancer';
import useLocalStore from '../../../hooks/useLocalStore';

const FJImageEnhancerRightContainer = () => {
    useLocalStore();
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const imageEnhancerCreationList = useSelector(state => state.imageEnhancer.imageEnhancerCreationList);
    const batchDownloadLoading = useSelector(state => state.common.batchDownloadLoading);

    const isEmptyCreationList = !imageEnhancerCreationList || imageEnhancerCreationList.length === 0;

    const dispatch = useDispatch();

    const uploadImg = files => {
        dispatch(FJActionImageEnhancer.uploadImagesAction(files));
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const downloadAll = () => {
        dispatch(FJActionImageEnhancer.downloadAllAction());
    };
    return (
        <FJImageEnhancerRight
            headerTabIndex={headerTabIndex}
            uploadImg={uploadImg}
            setIsDraggingFile={_setIsDraggingFile}
            imageEnhancerCreationList={imageEnhancerCreationList}
            taskStatus={taskStatus}
            downloadAll={downloadAll}
            batchDownloadLoading={batchDownloadLoading}
            isEmptyCreationList={isEmptyCreationList}
        />
    );
};
export default FJImageEnhancerRightContainer;
